import React from 'react';

// Utils
import { useTranslation } from 'next-i18next';
import { useAppContext } from '../../../src/store/AppContext';
import { useModal } from '../../../src/store/ModalContext';
import packagesTypes from '../../../src/enum/packagesTypes';

// Components
import Button from '../../atoms/Button/Button';
import Modal from '../../organisms/Modal/Modal';
import PlayersCounter from '../../organisms/Cart/PlayersCounter/PlayersCounter';

import styles from './MultiPlayersModal.module.scss';

function MultiPlayersModal() {
  const { t } = useTranslation();
  const [{ currentPlayer }] = useAppContext();
  const { isModalOpen, closeModal } = useModal();

  const getContent = () => {
    let textContent = t('booking.multiplayers.modal.text2');
    const type = currentPlayer?.typeId ? packagesTypes.find((p) => p.id === currentPlayer.typeId) : null;
    if (type) textContent += ` <strong>(${t(`package.type.${type.label}`).toLowerCase()})</strong>`;
    textContent += '<strong>.</strong>';
    return textContent;
  };

  return (
    <Modal
      id="modal-multiplayers"
      isOpen={isModalOpen('modal-multiplayers')}
      onClose={() => closeModal('modal-multiplayers')}
    >
      <section className={styles.modal}>
        <div className="flex a-center m-b-40 mobile-j-spb">
          <h2 className="fs-24 fw-700">{t('booking.multiplayers.modal.title')}</h2>
          <div className="m-l-20">
            <PlayersCounter />
          </div>
        </div>

        <div className="m-b-40 fw-400">
          <p>{t('booking.multiplayers.modal.text')}</p>
          <p
            className="m-t-20"
            dangerouslySetInnerHTML={{ __html: getContent() }}
          />
        </div>

        <Button
          full
          text="uppercase"
          onClick={() => closeModal('modal-multiplayers')}
        >
          {t('booking.multiplayers.modal.cta')}
        </Button>
      </section>
    </Modal>
  );
}

MultiPlayersModal.propTypes = {};

export default MultiPlayersModal;
